// @flow
//eslint-disable-next-line

import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useTranslation } from '../../../../../../hooks'
import { ANALYTICS_HELPER, CONSTANTS } from '../../../../../../utils'
import { MenuWrapper } from '../../../../../../containers'
import { alertActions } from '../../../../../../store/actions'

const WebMenuWrapper = () => {
	let dispatch = useDispatch()
	const translate = useTranslation()

	const { count } = useSelector((state) => state.cart.cart_items)
	const { showCartMenu, showProductDetail } = useSelector((state) => state.action)

	useEffect(() => {
		if (count === 0) {
			setOpen(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [count])

	useEffect(() => {
		setOpen(showCartMenu)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showCartMenu])

	useEffect(() => {
		setOpen(showCartMenu)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showProductDetail])

	const [open, setOpen] = useState(false)

	// const innerRef = useOuterClick(ev => {
	//     console.log(ev)
	//     // setOpen(false)
	// });

	const handleButtonClick = () => {
		if (count > 0) {
			setOpen(!open)

			ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
				action: ANALYTICS_HELPER.EVENT.NAVIGATION.CART_MENU.ACTION,
				label: ANALYTICS_HELPER.EVENT.NAVIGATION.CART_MENU.LABEL,
				properties: {},
			})
		} else {
			dispatch(
				alertActions.warning(translate('GENERAL.EMPTY_CART'), CONSTANTS.ERROR_TYPE.TOAST, true)
			)
		}
	}

	return (
		<>
			<div className={`dropdown ${open ? 'show' : ''} `}>
				<span className="nav-link" id="cart-button" onClick={handleButtonClick}>
					<div className="cartIcon">
						<span className="nav-link">
							<i className="icons-icon-cart"></i>
							{count >= 0 ? (
								<div className="cartCounter">
									<span>{count}</span>
								</div>
							) : (
								''
							)}
						</span>
					</div>
				</span>
				<div
					className="cartDropdown"
					// ref={innerRef}
				>
					<div className={`dropdown-menu  ${open ? 'show openMenu' : 'closeMenu'}`}>
						<ul className={`dropdown-list ${open ? 'show' : ''}`}>
							<div className="cartMenu cartSlideWrapper">
								<MenuWrapper />
							</div>
						</ul>
					</div>
				</div>
			</div>
		</>
	)
}

export default WebMenuWrapper
